<template>
  <div id="fuel-consumption-list">
    <div class="vx-card p-6 list-container">
      <div class="list-container-inner">
        <div class="control-header">

          <vs-row
            vs-align="flex-end"
            vs-type="flex"
            vs-justify="space-between"
            class="search-area"
          >
            <vs-col vs-lg="2" vs-sm="12" class="control-element">
              <vs-dropdown vs-trigger-click class="cursor-pointer" color="#2D9CDB">
                <div
                  class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
                >
                  <span class="mr-2">
                    {{
                      currentPage * paginationPageSize - (paginationPageSize - 1)
                    }}
                    -
                    {{
                      totalVoyageHistory - currentPage * paginationPageSize > 0
                        ? currentPage * paginationPageSize
                        : totalVoyageHistory
                    }}
                    / {{ totalVoyageHistory }}
                  </span>
                  <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                </div>
                <vs-dropdown-menu>
                  <vs-dropdown-item @click="onChangePageSize(10)">
                    <span>10</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="onChangePageSize(20)">
                    <span>20</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="onChangePageSize(30)">
                    <span>30</span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </vs-col>
            <vs-col vs-lg="4" vs-sm="0">
            </vs-col>
            <vs-col vs-lg="2" vs-sm="12" class="control-element">
              <label>操船者絞り込み</label>
              <v-select
                v-model="searchUserIds"
                multiple
                :closeOnSelect="false"
                :clearable="false"
                :options="optionUsers"
                name="searchUserIds"
                class="w-full"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
              >
                <template v-slot:no-options>操船者が見つかりません。</template>
              </v-select>
            </vs-col>
            <vs-col vs-lg="2" vs-sm="12" class="control-element">
              <label>船舶絞り込み</label>
              <v-select
                v-model="searchVesselIds"
                multiple
                :closeOnSelect="false"
                :clearable="false"
                :options="optionVessels"
                name="searchVesselIds"
                class="w-full"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
              >
                <template v-slot:no-options>船舶が見つかりません。</template>
              </v-select>
            </vs-col>
            <vs-col vs-lg="1" vs-sm="12" class="control-element">
              <vs-button class="search-button" @click="onSearch" color="#2D9CDB">検索</vs-button>
            </vs-col>
          </vs-row>
        </div>

        <div class="table-container">
          <div
            v-if="voyageData.length == 0 && dataReady"
            class="not-found-message-area"
          >
            <span class="not-found-message aisea-text-14-400-gray">航海データが見つかりませんでした</span>
          </div>
          <div class="table-area-wrapper">
            <div class="table-area">
              <div class="header row aisea-text-14-700-dark-gray">
                <div
                  class="cell"
                  v-for="(column, index) in columns"
                  :key="index"
                  :class="'cell-' + column.key"
                  :style="'width:' + column.width"
                >
                  {{column.label}}
                </div>
              </div>
              <div class="data row aisea-text-14-400-black"
                v-for="(rowData, index) in voyageData"
                @click="goToDetail(rowData)"
                :key="index">
                <div class="cell"
                  v-for="(column, index) in columns"
                  :key="index"
                  :class="'cell-' + column.key"
                  :style="'width:' + column.width">
                  <div v-if="column.key == 'startedAt' || column.key == 'endedAt'">
                    {{getJstTime(rowData[column.key])}}
                  </div>
                  <div v-else-if="rowData[column.key] == null">
                    -
                  </div>
                  <div v-else>
                    {{roundNumber(rowData[column.key])}}
                    {{column.unit}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="pagination-area">
          <vs-pagination color="#2D9CDB" :total="totalPages" :max="7" v-model="currentPage" />
        </div>
      </div>
      <error-dialog ref="errorDialog"></error-dialog>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import moment from "moment";
import vSelect from "vue-select";
import ErrorDialog from "../components/ErrorDialog";

export default {
  components: {
    vSelect,
    ErrorDialog,
  },
  data() {
    return {
      currentPage: 1,
      dataReady: false,

      paginationPageSize: 10,
      searchVesselIds: [],
      searchUserIds: [],
      columns: [
        {
          key: "vesselName",
          label: "船名",
          width: "140px",
          unit: null
        },
        {
          key: "startedAt",
          label: "出港",
          width: "140px",
          unit: null
        },
        {
          key: "endedAt",
          label: "入港",
          width: "140px",
          unit: null
        },
        {
          key: "seaRoute",
          label: "航路",
          width: "120px",
          unit: null
        },
        {
          key: "pilot",
          label: "操船者",
          width: "110px",
          unit: null
        },
        {
          key: "pitch",
          label: "平均ピッチ",
          width: "110px",
          unit: "min-1"
        },
        {
          key: "avelageCfo",
          label: "平均C重油消費量",
          width: "150px",
          unit: "L/H"
        },
        {
          key: "speed",
          label: "平均船速",
          width: "110px",
          unit: "kn"
        },
      ],
    }
  },
  async mounted() {
    let routerViewElement = document.getElementsByClassName("router-view")
    routerViewElement[0].style.padding = "2.2rem"

    await this.$store.dispatch("enterpriseVoyageHistory/getSearchInfo");

    this.dataReady = true
  },
  created() {
    this.searchVoyageHistories();
  },
  watch: {
    currentPage() {
      this.searchVoyageHistories();
    },
  },
  computed: {
    ...mapGetters({
      voyageHistories: "enterpriseVoyageHistory/getEnterpriseVoyageHistories",
      users: "enterpriseVoyageHistory/getSearchUsers",
      vessels: "enterpriseVoyageHistory/getSearchVessels"
    }),
    voyageData() {
      return this.voyageHistories.map(element => {
        let seaRoute = null;
        let averagePitch = null;
        let averageCfo = null;
        let averageSpeed = null;
        if (element.properties) {
          averagePitch = (element.properties.er_average_pitch != null) ? element.properties.er_average_pitch.toFixed(0) : null
          seaRoute = element.properties.route_name ? element.properties.route_name : null
          averageCfo = (element.properties.er_average_cfo_consumption != null) ? element.properties.er_average_cfo_consumption.toFixed(2) : null
          averageSpeed = (element.properties.er_average_speed != null) ? Number(element.properties.er_average_speed).toFixed(2) : null
        }

        return {
          vesselId: element.vessel.id,
          voyageId: element.id,
          vesselName: element.vessel.name_ja || element.vessel.name,
          startedAt: element.started_at,
          endedAt: element.ended_at,
          seaRoute: seaRoute,
          pilot: element.user.name,
          pitch: averagePitch,
          avelageCfo: averageCfo,
          speed: averageSpeed,
          properties: element.properties,
        }
      })
    },
    ...mapState({
      session: state => state.session.session,
      pageable: state => state.enterpriseVoyageHistory.pageable,
      defaultImage: function() {
        return "no_image_ship_s";
      }
    }),
    optionUsers() {
      return this.users.flatMap(d => {
        return { label: d.name || d.name_en, value: d.user_id };
      });
    },
    optionVessels() {
      return this.vessels.flatMap(d => {
        return { label: d.name_ja || d.name, value: d.id };
      });
    },
    totalPages() {
      if (this.pageable) return this.pageable.total_pages;
      else return 0;
    },
    totalVoyageHistory() {
      if (this.pageable) return this.pageable.total_elements;
      else return 0;
    }
  },
  methods: {
    ...mapActions({
      getEnterpriseVoyageHistories:
        "enterpriseVoyageHistory/getEnterpriseVoyageHistories",
      setVoyageHistoryDetail:
        "ecoShip/setVoyageHistoryDetail",
    }),
    async searchVoyageHistories() {
      let requestParams = {
        user_ids: this.searchUserIds.flatMap(e => e.value),
        vessel_ids: this.searchVesselIds.flatMap(e => e.value),
        page: this.getCurrentPage(),
        limit: this.paginationPageSize
      };
      this.$vs.loading();
      await this.$store
        .dispatch(
          "enterpriseVoyageHistory/getEnterpriseVoyageHistories",
          requestParams
        )
        .finally(() => {
          this.$vs.loading.close();
        });
    },
    goToDetail(voyageData) {
      if ( voyageData.endedAt === null) {
        this.$refs.errorDialog.open("エラー", "入港していないため、燃料消費レポートを表示できません。", null)
      } else {
        this.setVoyageHistoryDetail(voyageData);
        this.$router.push({
          name: "addon-eco-ship-fuel-consumption-detail",
        });
      }
    },
    getJstTime(time) {
      let convertTime = moment(time).format("YYYY/MM/DD HH:mm")
      if (convertTime === "Invalid date") {
        convertTime = "-"
      }
      return convertTime;
    },
    getCurrentPage() {
      return this.currentPage - 1;
    },
    onSearch() {
      this.currentPage = 1;
      this.searchVoyageHistories();
    },
    onChangePageSize(size) {
      this.paginationPageSize = size

      this.currentPage = 1;
      this.searchVoyageHistories();
    },
    roundNumber(target) {
      return typeof target == 'number' ? Math.round(target * 100) / 100 : target
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";
@import "@/assets/scss/aisea/_typography.scss";

#fuel-consumption-list {
  .not-found-message-area {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    position: absolute;
  }
  .table-area {
    width: fit-content;
  }
  .table-container {
    position: relative;
  }
  .table-area-wrapper {
    overflow-x: scroll;
    position: relative;
    height: 560px;
  }
  .control-header {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 20px;
    .control-element {
      margin-top: 10px;
      margin-bottom: 10px;
    }
    .search-area {
      margin-left: auto;
    }
    .search-button {
      display: block;
      margin-left: auto;
    }
  }

  .pagination-area {
    margin-top: 20px;
  }
  .header {
    font-weight: bold;
  }
  .row {
    min-height: 49px;
    height: fit-content;
    display: flex;
    border-bottom: solid 1px #e2e2e2;
  }
  .data.row {
    cursor: pointer;
  }
  .cell {
    display: flex;
    margin-right: 20px;
    padding: 5px 10px;
    align-items: center;
    &.cell-vesselName {
      overflow-wrap: anywhere;
    }
  }
}
</style>
